import { RequestSender } from "./helpers";

type PaymentCheckoutSessionInput = {
  readonly items: ReadonlyArray<{
    readonly priceLookupKey: string;
    readonly quantity?: number;
    readonly studentIds?: ReadonlyArray<string>; // ✅ optional now
  }>;
  readonly successUrl: string;
  readonly cancelUrl: string;
};

async function createPaymentCheckoutSession(
  request: RequestSender,
  input: PaymentCheckoutSessionInput,
): Promise<string> {
  console.log("input: ", input.items[0].priceLookupKey);
  console.log(
    "input contd: ",
    input.items[0].quantity
      ? input.items[0].quantity
      : input.items[0].studentIds,
  );
  const response = await request<{ redirectUrl: string }>(
    "post",
    `/profile/payment-checkout-sessions`,
    input,
  );

  if (response.data.message !== "success") {
    throw new Error(response.data.message);
  }
  if (!response.data.data) {
    throw new Error("Invalid response");
  }
  return response.data.data.redirectUrl;
}

export type { PaymentCheckoutSessionInput };
export default createPaymentCheckoutSession;
